import { render, staticRenderFns } from "./teamTarget.vue?vue&type=template&id=bd578e86&"
import script from "./teamTarget.vue?vue&type=script&lang=js&"
export * from "./teamTarget.vue?vue&type=script&lang=js&"
import style0 from "./teamTarget.vue?vue&type=style&index=0&id=bd578e86&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports